var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.751,
    height: 18.774,
    viewBox: "0 0 14.751 18.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-text",
    transform: "translate(-5.625 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    "data-name": "Path 4390",
    d: "M20.208,10.3H14.341A2.011,2.011,0,0,1,12.33,8.284V2.417a.167.167,0,0,0-.167-.167H8.307A2.682,2.682,0,0,0,5.625,4.932v13.41a2.682,2.682,0,0,0,2.682,2.682h9.387a2.682,2.682,0,0,0,2.682-2.682V10.463A.167.167,0,0,0,20.208,10.3ZM16.353,17h-6.7a.67.67,0,1,1,0-1.341h6.7a.67.67,0,1,1,0,1.341Zm0-3.352h-6.7a.67.67,0,0,1,0-1.341h6.7a.67.67,0,1,1,0,1.341Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4391",
    "data-name": "Path 4391",
    d: "M25.294,9.159,19.268,3.133a.084.084,0,0,0-.143.059v5.44a.67.67,0,0,0,.67.67h5.44a.084.084,0,0,0,.059-.143Z",
    transform: "translate(-5.454 -0.347)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.691825abe02bbdc004bb9d24aff298d3.svg";
export { ForwardRef as ReactComponent };